import React, { useState } from "react";
import '../../assets/styles/dashboard.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import commonService from "../../services/otherServices";

const Advertisment: React.FC = () => {
    const [showAvailPopup, setShowAvailUpdatePopup] = useState(false);
    const [showContactPopup, setShowContactUpdatePopup] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isApiLoading, setIsApiLoading] = useState(false);

    const handleSubmit = async (type: string) => {
        try {
            if (type === 'discount') {
                setIsLoading(true);
            } else if (type === 'api') {
                setIsApiLoading(true);
            }
            const requestData = {
                request_type: type
            };
            await commonService.request(requestData);
            if (type === 'discount') {
                setShowAvailUpdatePopup(true);
            } else if (type === 'api') {
                setShowContactUpdatePopup(true)
            }
        } catch (error) {
            console.error('Error submitting request:', error);
        }
        finally {
            setIsLoading(false);
            setIsApiLoading(false);
        }
    };

    return (
        <>
            <div className="dashboard-box-wrapper">
                <div className="dashboard-white-box">
                    <div className="d-flex flex-row justify-content-between">
                        <div>
                            <p className="limited-time">Limited-Time Offer!</p>
                            <p className="unlock">Unlock <strong>30% Off</strong> Your <br />Ideal B2B Data List</p>
                            <button
                                type="button"
                                disabled={isLoading}
                                className={`avail-now ${isLoading ? 'no-arrow' : ''}`}
                                onClick={() => handleSubmit('discount')}
                            >
                                {isLoading ? <><span style={{ fontSize: "10px" }} className="spinner-border spinner-border-sm me-2" />Processing...</> : "Avail Now"}
                            </button>
                        </div>
                        <div>
                            <img src="images/arrow-plate.png" className={`arrow ${isLoading ? 'd-none' : ''}`} alt="" />
                        </div>
                    </div>

                    {showAvailPopup && (
                        <div className="avail-popup-overlay">
                            <div className="avail-popup">
                                <div className="d-flex flex-row justify-content-end">
                                    <div
                                        className="page-icon"
                                        onClick={() => setShowAvailUpdatePopup(false)}
                                    >
                                        <img
                                            src="/images/close-inactive.png"
                                            alt="normal"
                                            className="icon-normal"
                                        />
                                        <img
                                            src="/images/close-active.png"
                                            alt="hover"
                                            className="icon-hover"
                                        />
                                    </div>

                                </div>

                                <div className="text-center">
                                    <img src="/images/green-arrow.png" alt="" />
                                    <p className="popup-title">Congratulations</p>
                                    <p className="popup-text">
                                        You have availed 30% Discount on your next purchase. Please feel free to reach out to us on reach@datacaptive.com and share your new requirement and our Business Development Associate will get in touch you soon.
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="dashboard-white-box-1">
                    <div className="d-flex flex-row justify-content-between">
                        <div>
                            <p className="limited-time">Integrate Seamlessly with <br /> Data API</p>
                            <p className="unlock">Access <strong>150M+ Verified B2B Contacts</strong> <br /> by integrating our API with your CRM.</p>
                            <button
                                type="button"
                                className={`avail-now ${isApiLoading ? 'no-arrow' : ''}`}
                                disabled={isApiLoading}
                                onClick={() => handleSubmit('api')}
                            >
                                {isApiLoading ? <><span style={{ fontSize: "10px" }} className="spinner-border spinner-border-sm me-2" />Processing...</> : "Connect Now"}
                            </button>
                            {showContactPopup && (
                                <div className="avail-popup-overlay">
                                    <div className="avail-popup">
                                        <div className="d-flex flex-row justify-content-end">
                                            <div
                                                className="page-icon"
                                                onClick={() => setShowContactUpdatePopup(false)}
                                            >
                                                <img
                                                    src="/images/close-inactive.png"
                                                    alt="normal"
                                                    className="icon-normal"
                                                />
                                                <img
                                                    src="/images/close-active.png"
                                                    alt="hover"
                                                    className="icon-hover"
                                                />
                                            </div>
                                        </div>

                                        <div className='text-center'>
                                            <img src="/images/green-api.png" alt="" />
                                            <p className="popup-title">Thank you</p>
                                            <p className="popup-text">
                                                For choosing to opt to get API integrated with your data needs. Our <br /> BDA will get in touch with you soon.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                        <div>
                            <img src="images/api-pannel.png" className="arrow" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default Advertisment;